<template>
  <button
    v-if="isReady"
    class="estimateWidget"
    @click="estimateArta"
  >
    Estimate Shipping
  </button>
</template>

<script>
import Arta from "@artaio/arta-browser";

export default {
    name: 'ArtaEstimateWidget',
    props: [
        'item',
        'apiKey'
    ],
    data () {
        return {
            estimate: null
        }
    },
    computed: {
        /**
         * Check if the Arta estimate is ready
         */
        isReady () {
            return this.estimate && this.estimate.isReady;
        },
        /**
         * Get the settings for the Arta estimate request
         */
        requestSettings () {
            const internalReference = `Inventory ${this.item.inventory_id} - Auction ${this.item.auction_id}`;
            const publicReference = `Lot Number ${this.item.display_lotnumber}`;
            const quantity = this.item.quantity || 1;
            const objects = Array.from({ length: quantity }, () => ({
                details: {
                    title: this.item.lead,
                },
                depth: parseFloat(this.item.depth_in),
                width: parseFloat(this.item.width_in),
                height: parseFloat(this.item.height_in),
                subtype: this.item.arta_subtype,
                unit_of_measurement: 'in',
                weight_unit: 'lb',
                value_currency: 'USD',
                value: parseFloat(this.item.max_avg),
                weight: parseFloat(this.item.weight_lb),
                internal_reference: internalReference,
                public_reference: publicReference
            }));
            return {
                apiKey: this.apiKey,
				insurance: 'arta_transit_insurance',
                internal_reference: internalReference,
                public_reference: publicReference,
				objects: objects,
				origin: {
                    address_line_1: '620 Cornerstone Court',
                    city: 'Hillsborough',
                    region: 'NC',
                    country: 'US',
                    postal_code: '27278'
				}
            }
        },
    },
    mounted () {
        Arta.init(this.apiKey);
        this.estimate = Arta.estimate(this.requestSettings);
        this.estimate.validate().catch((error) => {
            console.error('Arta estimate validation error:', error);
        });
    },
    methods: {
        /**
         * Open the Arta estimate widget
         */
        estimateArta () {
            if (this.estimate) {
                this.estimate.open();
            }
        }
    },
}
</script>

<style scoped>
    button.estimateWidget {
        border: 1px solid rgb(0,122,255);
        color: rgb(0,122,255);
        margin: 0 32px 32px 0;
    }
</style>
